// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isDefined(value: any): boolean {
  return typeof value !== 'undefined' && value !== null;
}
